function track(nameSpace, name, properties) {
    var eventType = "".concat(nameSpace, ".track");
    var event = new CustomEvent(eventType, {
        detail: {
            name: name,
            properties: properties,
        },
    });
    document.dispatchEvent(event);
}
export default {
    track: track,
};
